module.exports = __webpack_public_path__ + "static/media/ludo.1fb185e6.gif";